import type { FC } from 'react';
import React from 'react';

import { DEFAULT_MAX_OPTION } from './config';
import type { TInputAutocomplete } from './models';
import { checkShow } from './utils';

export const InputAutocomplete: FC<TInputAutocomplete> = ({
    Input,
    list = [],
    listId,
    maxOption = DEFAULT_MAX_OPTION,
    value = '',
    ...rest
}) => {
    return (
        <div>
            <Input list={listId} value={value} {...rest} />
            {checkShow({ list, value }) && (
                <datalist id={listId}>
                    {list.slice(0, maxOption).map(option => (
                        <option key={option} value={option} />
                    ))}
                </datalist>
            )}
        </div>
    );
};
